import store from '@/store/store'
import app from '@/main'
import i18n from '@/i18n/i18n'
import mallet from '@/assets/mallet.ogg'

export default socket => {
  socket.on('chat', function(data) {
    const payload = { data }
    payload.chatData = store.getters['chat/chatDataOfUser'](data.from)
    store.commit('chat/RECEIVE_CHAT_MESSAGE', payload)

    const activeUser = store.getters['chat/activeChatUser']
    if (activeUser) {
      if (activeUser !== data.from) app.$notifySuccess(i18n.t('chats.new_message_notify'))
      if (activeUser === data.from && app.$route.name === 'chat')
        store.dispatch('chat/markSeenAllMessages', data.from)
    }
    new Audio(mallet).play()
  })
}
